import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './NavigationBar.css';

const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsMenuOpen(false); // 关闭菜单
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // 定义导航项和对应的路径
  const navItems = [
    { name: '首页', path: '/' },
    { name: '产品与资质', path: '/product/' },
    { name: '企业与品牌', path: '/about/brand-and-company/' },
    { name: '常见问题', path: '/faq/' },
    { name: '官方渠道', path: '/official-channels/' },
    { name: '下载软件', path: '/download/' }
  ];

  return (
    <header className="header">
      <nav className="navbar">
        <div className="nav-logo" onClick={() => handleNavigation('/')}>
          <img src="/msl_logo.png" alt="妙视力Logo" width={72} height={59}/>
        </div>
        
        {/* 汉堡菜单按钮 */}
        <div className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        
        {/* 导航项容器 */}
        <div className={`nav-items ${isMenuOpen ? 'expanded' : ''}`}>
          {navItems.map((item, index) => (
            <div 
              key={index}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleNavigation(item.path)}
            >
              {item.name}
            </div>
          ))}
        </div>
        
        <div className="nav-cta">
            <img src="/nav_cta.png" width={107} height={62} alt="妙视力1V1专属服务"/>
          {/*<button className="cta-button">1V1 领取体验课</button>*/}
        </div>
      </nav>
    </header>
  );
};

export default NavigationBar;